import * as React from 'react';
import './Switch.scss';
const classnames = require('classnames');

interface SwitchProps {
  id?: string;
  checked: boolean;
  size: 'sm' | 'lg';
  disabled?: boolean;
  onChange(e);
}

export const Switch = ({ id, checked, onChange, size, disabled }: SwitchProps) => {
  const className = classnames('switch-indicator', {
    'switch-indicator-lg': size === 'lg',
    'switch-indicator-disabled': disabled,
  });

  return (
    <div className='switch-indicator-wrapper'>
      <input
        type='checkbox'
        name={id}
        id={id}
        className='switch'
        checked={checked}
        onChange={onChange}
        disabled={!!disabled}
      />
      <label htmlFor={id} className={className} />
    </div>
  );
};
